import BannerStock from 'assets/png/hav-stock-2.png'

export const slides = [
  {
    title: 'Portal de Vendas',
    description:
      'Buscando facilitar o acesso aos nossos produtos, criamos um espaço exclusivo para você. Confira!',
    image: BannerStock
  }
]
